function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M149.3,288V21.5c-8.9-6.7-20-10.8-32-10.8h-64C23.9,10.7,0,34.6,0,64v170.7C0,264.1,23.9,288,53.3,288H149.3z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M485.7,165.3c3.3-6.5,5-13.8,5-21.3c0-18.5-10.6-34.8-26.4-42.7c4.9-9.7,6.3-20.9,3.9-32C463.4,47.7,443.1,32,419.8,32 H224c-14,0-36,4.4-53.3,12.6v228.7l2.6,1.3l61.4,133.1V480c0,3.2,1.5,6.3,4,8.3c0.7,0.5,16.5,13,38.7,13c24.7,0,64-39.1,64-85.3 c0-29.2-10.5-65.5-17-85.3h131.8c28.7,0,53.1-21.2,55.6-48.4c1.4-15.2-3.7-29.8-13.7-40.7c8.8-8.8,13.9-20.8,13.9-33.6 C512,189.5,501.4,173.3,485.7,165.3z"
})));

var SvgThumbsDown = function SvgThumbsDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThumbsDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/thumbs-down.7850e2bb.svg";
export { ForwardRef as ReactComponent };